import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import DriverApp from './DriverApp';
import TrackingPage from './TrackingPage';
import SignupPage from './SignupPage';
import ResetPasswordPage from './ResetPasswordPage';
import LegalPage from './LegalPage';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.2,
    replaysOnErrorSampleRate: 1.0,
  });
}

const path = window.location.pathname;
const isDriverApp    = path.startsWith('/driver');
const isTrackingPage = path.startsWith('/track');
const isSignupPage   = path.startsWith('/signup');
const isResetPage    = path.startsWith('/reset-password') || path.startsWith('/forgot');
const isLegalPage    = path.startsWith('/terms') || path.startsWith('/privacy');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {isDriverApp ? <DriverApp />
     : isTrackingPage ? <TrackingPage />
     : isSignupPage ? <SignupPage />
     : isResetPage ? <ResetPasswordPage />
     : isLegalPage ? <LegalPage />
     : <App />}
  </React.StrictMode>
);